// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './AuthContext'; // Import the AuthProvider

// Global: allow closing the top-most open modal with Escape.
// We simulate clicking the visible .modal-x button so each page's own close handler runs.
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;

  const modals = document.querySelectorAll('.modal');
  if (!modals || modals.length === 0) return;

  const topModal = modals[modals.length - 1];
  const buttons = topModal.querySelectorAll('button.modal-x');
  const btn = buttons && buttons.length ? buttons[buttons.length - 1] : null;
  if (btn) {
    e.preventDefault();
    btn.click();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //<React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  //</React.StrictMode>
);

// Optionally measure performance in your app
reportWebVitals();
